import { useMemo } from 'react';

export const useRandomItem = (items: any[]) => {
  const item = useMemo(() => items[Math.floor(Math.random() * items.length)], [items]);
  return item;
};
